export function initCompanyArchiveAreaSearchForm(root = document, navigate = (url) => window.location.assign(url)) {
  const forms = root.querySelectorAll('.js-company-archive-area-search-form')

  forms.forEach((form) => {
    if (form.dataset.companyArchiveAreaSearchFormInitialized === 'true') {
      return
    }

    const prefectureSelect = form.querySelector('.js-company-archive-search-prefecture')
    const citySelect = form.querySelector('.js-company-archive-search-city')
    const cityName = form.querySelector('.js-company-archive-search-city-name')
    const cityCount = form.querySelector('.js-company-archive-search-city-count')

    if (!prefectureSelect || !citySelect) {
      return
    }

    form.dataset.companyArchiveAreaSearchFormInitialized = 'true'
    const cityOptionsUrl = form.dataset.cityOptionsUrl || ''

    const syncCityDisplay = () => {
      if (!cityName || !cityCount) {
        return
      }

      const selectedCity = citySelect.selectedOptions[0]
      cityName.textContent = selectedCity ? (selectedCity.dataset.cityName || selectedCity.textContent.trim()) : '市区町村を選択'
      cityCount.textContent = selectedCity ? (selectedCity.dataset.countLabel || '') : ''
    }

    const cityPlaceholderOption = () => {
      const option = document.createElement('option')
      option.value = ''
      option.dataset.cityName = '市区町村を選択'
      option.textContent = '市区町村を選択'
      return option
    }

    const syncCityOptions = () => {
      const selectedPrefecture = prefectureSelect.selectedOptions[0]
      const selectedPrefectureSlug = selectedPrefecture ? selectedPrefecture.dataset.prefectureSlug : ''
      let selectableCityCount = 0

      Array.from(citySelect.options).forEach((option) => {
        if (!option.value) {
          option.hidden = false
          option.disabled = false
          return
        }

        const matchesPrefecture = selectedPrefectureSlug !== '' && option.dataset.prefectureSlug === selectedPrefectureSlug
        const hasCompanies = option.dataset.hasCompanies !== '0'
        option.hidden = !matchesPrefecture
        option.disabled = !matchesPrefecture || !hasCompanies

        if (matchesPrefecture && hasCompanies) {
          selectableCityCount += 1
        }
      })

      const selectedCity = citySelect.selectedOptions[0]
      if (selectedCity && (selectedCity.hidden || selectedCity.disabled)) {
        citySelect.value = ''
      }

      citySelect.disabled = selectedPrefectureSlug === '' || selectableCityCount === 0
      syncCityDisplay()
    }

    const replaceCityOptionsWithPlaceholder = () => {
      citySelect.replaceChildren(cityPlaceholderOption())
      form.dataset.cityLoadedPrefectureSlug = ''
    }

    const cityOptionsRequestUrl = (prefectureSlug) => {
      const url = new URL(cityOptionsUrl, window.location.origin)
      url.searchParams.set('hapisumu_area_search_prefecture', prefectureSlug)
      return url.toString()
    }

    const selectedPrefectureSlug = () => prefectureSelect.selectedOptions[0]?.dataset.prefectureSlug || ''

    let cityOptionsRequestSequence = 0

    const loadCityOptionsForSelectedPrefecture = async () => {
      const requestSequence = ++cityOptionsRequestSequence
      const requestedPrefectureSlug = selectedPrefectureSlug()

      if (!cityOptionsUrl) {
        syncCityOptions()
        return
      }

      if (requestedPrefectureSlug === '') {
        replaceCityOptionsWithPlaceholder()
        syncCityOptions()
        return
      }

      if (form.dataset.cityLoadedPrefectureSlug === requestedPrefectureSlug) {
        syncCityOptions()
        return
      }

      citySelect.disabled = true
      if (cityName) cityName.textContent = '読み込み中...'
      if (cityCount) cityCount.textContent = ''

      try {
        const response = await fetch(cityOptionsRequestUrl(requestedPrefectureSlug), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        if (!response.ok) throw new Error(`Failed to load city options: ${response.status}`)

        const html = await response.text()
        if (requestSequence !== cityOptionsRequestSequence || selectedPrefectureSlug() !== requestedPrefectureSlug) {
          return
        }

        citySelect.innerHTML = html
        form.dataset.cityLoadedPrefectureSlug = requestedPrefectureSlug
        syncCityOptions()
      } catch (error) {
        if (requestSequence !== cityOptionsRequestSequence || selectedPrefectureSlug() !== requestedPrefectureSlug) {
          return
        }

        replaceCityOptionsWithPlaceholder()
        syncCityOptions()
      }
    }

    prefectureSelect.addEventListener('change', () => {
      loadCityOptionsForSelectedPrefecture()
    })
    citySelect.addEventListener('change', syncCityDisplay)
    form.addEventListener('submit', (event) => {
      event.preventDefault()

      const cityUrl = citySelect.disabled ? '' : citySelect.value
      const prefectureUrl = prefectureSelect.value
      const defaultUrl = form.dataset.defaultUrl || ''
      const destinationUrl = cityUrl || prefectureUrl || defaultUrl

      if (destinationUrl) {
        navigate(destinationUrl)
      }
    })

    syncCityOptions()
  })
}
